import {connect} from "react-redux"
import {createSelector} from "reselect"
import State from "../../models/State"
import {isPriceFilter} from "../../models/Filter/typeGuards"
import getLocaleFromHeaders from "../../utils/getLocaleFromHeaders"
import getRealmFromHeaders from "../../utils/getRealmFromHeaders"
import {FilterPrice} from "../../models/Filter"

const priceFilterSelector = createSelector(
    (state: State) => state.search.filters,
    filters => Object.values(filters).find(filter => isPriceFilter(filter)) as FilterPrice,
)
export const mapStateToProps = (state: State) => {
    const {globalPriceFormattingConfig} = state.search
    const {headers} = state.request
    const locale = getLocaleFromHeaders(headers)
    const realm = getRealmFromHeaders(headers)
    const {text} = state

    const priceFilter = priceFilterSelector(state)

    return {
        priceFilter,
        locale,
        realm,
        text,
        globalPriceFormattingConfig,
    }
}

export const connector = connect(mapStateToProps)
